import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  globalSearch: {
    width: '100%',
  },
  globalSearchResult: {
    zIndex: 1000,
  },
  globalSearchResultPaper: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  globalSearchResultItem: {
    padding: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    border: `1px solid transparent`,
    borderRadius: theme.spacing(0.5),

    '&:hover': {
      cursor: 'pointer',
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  globalSearchResultCategoryName: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));
